"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _validate = require("@/libs/validate1");
var _user = require("@/api/user/user");
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          name: [{
            required: true,
            message: "请输入管理员姓名",
            trigger: "blur"
          }, {
            min: 2,
            max: 12,
            message: "长度在 2 到 12 个字符",
            trigger: "blur"
          }],
          uniqueCode: [{
            required: true,
            message: "请输入编号",
            trigger: "blur"
          }],
          loginName: [{
            required: true,
            message: "请输入登录账号",
            trigger: "blur"
          }],
          courseLeader: [{
            required: true,
            message: "请输入负责人姓名",
            trigger: "blur"
          }],
          faculty: [{
            required: true,
            message: "请输入课程负责人所在院系",
            trigger: "blur"
          }],
          schoolId: [{
            required: true,
            message: "请输入所属学校",
            trigger: "blur"
          }],
          password: [{
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }, {
            validator: _validate.PSWRULE,
            trigger: "blur"
          }]
        },
        labelWidth: "160px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [
        // {
        //   span: 12,
        //   type: "selectX",
        //   label: "所属学校：",
        //   isDisabled: false,
        //   multiple: false,
        //   placeholder: "请输入所属学校",
        //   prop: "schoolId",
        //   value: [],
        //   options: []
        // },
        {
          type: "input",
          label: "姓名：",
          isDisabled: false,
          placeholder: "请输入姓名",
          prop: "name",
          value: "",
          span: 12
        }, {
          span: 12,
          type: "input",
          label: "登录账号：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入登录账号",
          prop: "loginName",
          value: ""
        }, {
          span: 12,
          type: "input",
          label: "负责人姓名：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入负责人姓名",
          prop: "courseLeader",
          value: ""
        }, {
          span: 12,
          type: "input",
          label: "负责人工号：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入负责人工号",
          prop: "jobNumber",
          value: ""
        }, {
          span: 12,
          type: "input",
          label: "负责人所在院系：",
          isDisabled: false,
          multiple: false,
          placeholder: "请输入课程负责人所在院系",
          prop: "faculty",
          value: ""
        }, {
          type: "password",
          label: "密码",
          isDisabled: false,
          placeholder: "请输入密码",
          prop: "password",
          value: "",
          required: true,
          span: 12
        }
        // {
        //   type: "radio",
        //   label: "设为默认管理员：",
        //   isDisabled: false,
        //   prop: "isSys",
        //   value: "1",
        //   span: 12,
        //   options: [
        //     { name: "是", value: "1", isDisabled: true },
        //     { name: "否", value: "2", isDisabled: false }
        //   ]
        // }
        ]
      },
      id: '',
      isAdd: 1
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      if (this.isAdd) {
        (0, _user.addUser)({
          name: e.name,
          courseLeader: e.courseLeader,
          faculty: e.faculty,
          userType: 3,
          isExpert: 0,
          isPlatUser: 1,
          loginName: e.loginName,
          password: e.password,
          jobNumber: e.jobNumber
        }).then(function (res) {
          if (res.code === 2000) {
            _this.$message.success("操作成功。");
            history.go(-1);
          }
        });
      } else {
        (0, _user.updateUser)({
          id: this.id,
          name: e.name,
          courseLeader: e.courseLeader,
          faculty: e.faculty,
          userType: 3,
          isExpert: 0,
          isPlatUser: 1,
          loginName: e.loginName,
          password: e.password,
          jobNumber: e.jobNumber
        }).then(function (res) {
          if (res.code === 2000) {
            _this.$message.success("操作成功。");
            history.go(-1);
          }
        });
      }
    }
  },
  created: function created() {
    if (this.$route.query.item) {
      var item = this.$route.query.item;
      console.log('item', item);
      this.id = item.id;
      this.formData.formItem[0].value = item.name;
      this.formData.formItem[1].value = item.loginName;
      this.formData.formItem[1].isDisabled = true;
      this.formData.formItem[2].value = item.courseLeader;
      this.formData.formItem[3].value = item.jobNumber;
      this.formData.formItem[4].value = item.faculty;
      this.formData.formItem[5].value = item.password;
      this.isAdd = 0;
    }
  }
};